import { Button, ButtonProps } from '@wegroup/design-system';
import React, { forwardRef, PropsWithChildren } from 'react';

interface Props {
  icon: React.ReactElement;
  isPrimary?: boolean;
}

const OfferAction = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Props & ButtonProps>
>(({ icon, isPrimary, children, ...otherProps }, ref) => {
  return (
    <Button
      size="sm"
      w="100%"
      leftIcon={icon}
      variant={isPrimary ? 'primary' : 'white'}
      borderRadius="0"
      border="none"
      p="6"
      color={isPrimary ? undefined : 'gray.700'}
      ref={ref}
      {...otherProps}
    >
      {children}
    </Button>
  );
});

export default OfferAction;
